<h1 mat-dialog-title>{{ 'ASSISTANCES_MODAL.TITLE' | translate }}</h1>
<div mat-dialog-content>
  <div>
    <p>{{ 'ASSISTANCES_MODAL.CONTENT' | translate }}</p>
  </div>
  <form #assistanceForm="ngForm">
    <mat-form-field style="display:inline">
      <mat-label>{{ 'ASSISTANCES_MODAL.NAME' | translate }}</mat-label>
      <input matInput placeholder="{{ 'ASSISTANCES_MODAL.NAME' | translate }}" #name="ngModel" name="name" [(ngModel)]="assistance.name" required maxlength="150" whitespace>
      @if (name.invalid && name.errors?.['required']) {
        <mat-error>{{ 'ERROR.FIELD_REQUIRED' | translate }}</mat-error>
      }
      @if (name.invalid && name.errors?.['whitespace'] && !name.errors?.['required']) {
        <mat-error>{{ 'ERROR.NOT_ONLY_WHITESPACE' | translate }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field style="display:inline">
      <mat-label>{{ 'ASSISTANCES_MODAL.COMMENTS' | translate }}</mat-label>
      <textarea matInput placeholder="{{ 'ASSISTANCES_MODAL.COMMENTS' | translate }}" #comments="ngModel" name="comments" [(ngModel)]="assistance.comments" maxlength="5000" whitespace></textarea>
      @if (comments.invalid && comments.errors?.['whitespace']) {
        <mat-error>{{ 'ERROR.NOT_ONLY_WHITESPACE' | translate }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field style="display:inline">
      <mat-label>{{ 'ASSISTANCES_MODAL.PRIORITY' | translate }}</mat-label>
      <mat-select #priority="ngModel" name="priority" [(ngModel)]="assistance.priority" panelwidth="auto">
        @for (key of objectKeys(assistancePriorityEnum); track key) {
          <mat-option [value]="assistancePriorityEnum[key]">{{ 'ASSISTANCES_PRIORITY.' + key | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">{{'MODAL.CANCEL' | translate}}</button>
  <button mat-button (click)="onSubmit(assistanceForm,true)" [disabled]="assistanceForm.invalid"> {{'MODAL.ACCEPT_AND_SEND' | translate }}</button>
  <button mat-button (click)="onSubmit(assistanceForm,false)" [disabled]="assistanceForm.invalid">{{ 'MODAL.ACCEPT' | translate }}</button>
</div>
